import { supabase } from '../lib/supabase';

/**
 * Get user's nickname from user metadata
 * @param {object} user - Supabase user object
 * @returns {string|null} User's nickname or null
 */
export const getUserNickname = (user) => {
  if (!user) return null;
  return user.user_metadata?.nickname || null;
};

/**
 * Update user's nickname in Supabase
 * @param {string} nickname - New nickname
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export const updateUserNickname = async (nickname) => {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
      return {
        success: false,
        error: 'User not authenticated',
      };
    }

    const { error } = await supabase.auth.updateUser({
      data: {
        nickname: nickname.trim(),
      },
    });

    if (error) {
      return {
        success: false,
        error: error.message || 'Failed to update nickname',
      };
    }

    return {
      success: true,
    };
  } catch (error) {
    return {
      success: false,
      error: error.message || 'An error occurred while updating nickname',
    };
  }
};

